import {
  As,
  Box,
  CSSObject,
  Icon,
  Text,
  Tooltip,
  useMultiStyleConfig,
} from '@chakra-ui/react';

export type BadgeSizes = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export interface BadgeProps {
  badgeProps?: CSSObject;
  badgeSize?: BadgeSizes;
  containerProps?: CSSObject;
  contentProps?: CSSObject;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon?: As<any>;
  iconProps?: CSSObject;
  tooltip?: React.ReactNode;
  tooltipProps?: CSSObject;
  children?: React.ReactNode;
}

export const Badge = (props: BadgeProps) => {
  const {
    badgeProps,
    children,
    containerProps,
    contentProps,
    icon,
    iconProps,
    tooltip,
    tooltipProps,
  } = props;
  const styles = useMultiStyleConfig('Badge', props);

  return (
    <Box sx={{ ...styles.BadgeContainer, ...containerProps }}>
      <Tooltip label={tooltip} sx={{ ...styles.Tooltip, ...tooltipProps }}>
        <Box sx={{ ...styles.BadgeDiv, ...badgeProps }}>
          {icon && <Icon as={icon} sx={{ ...styles.Icon, ...iconProps }} />}
          <Text sx={{ ...styles.Content, ...contentProps }}>{children}</Text>
        </Box>
      </Tooltip>
    </Box>
  );
};
